import * as React from 'react';
import { Alert } from '@duxton-web/ui';
import moment from 'moment';

interface StatusProps {
  state: string;
  updatedBy: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  expireAt: string;
}

function getCreateMessage(createdBy, createdAt) {
  return `The rollout changes was made by ${createdBy} on ${moment(
    createdAt,
  ).format('MMM D, YYYY h:mm A')}`;
}

function getUpdateMessage(state, updatedBy, updatedAt) {
  return state != 'pending'
    ? `and ${state} by ${updatedBy} on ${moment(updatedAt).format(
        'MMM D, YYYY h:mm A',
      )}`
    : '';
}

function getExpireMessage(state, expireAt) {
  return state == 'pending'
    ? moment().diff(moment(expireAt)) < 0
      ? `and will expire on ${moment(expireAt).format('MMM D, YYYY h:mm A')}`
      : `and has expired on ${moment(expireAt).format('MMM D, YYYY h:mm A')}`
    : '';
}

const StatusMessage: React.FC<StatusProps> = function (props: StatusProps) {
  const { createdBy, createdAt, state, updatedBy, updatedAt, expireAt } = props;
  return (
    <div>
      <Alert
        message={`${getCreateMessage(createdBy, createdAt)} ${getUpdateMessage(
          state,
          updatedBy,
          updatedAt,
        )} ${getExpireMessage(state, expireAt)}`}
        type="info"
      />
    </div>
  );
};

export default StatusMessage;
